/* eslint-disable no-unused-vars */
import React from 'react';
import style from './adminHeader.module.scss';
import Logo from 'icons/logo';
import { Link } from 'react-router-dom';
import MessageBubble from 'icons/userPlus';
import IconUserCard from 'icons/userCard';
import ExitIcon from 'icons/exit';
import { useAppDispatch } from 'store/hooks';
import { dropResponse } from 'store/admin/adminSlice';
import cx from 'classnames';

export default function AdminHeader({ entity }: { entity: string }) {
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(dropResponse());
  };

  return (
    <div className={style.container}>
      <Link to="/">
        <Logo className={style.logo}></Logo>
      </Link>
      <div className={style.items}>
        <Link
          className={cx(
            style.item,
            entity === 'requests' || entity === 'admin' ? style.current : ''
          )}
          to={'/admin/requests'}
          onClick={onClick}
        >
          <MessageBubble className={style.icon}></MessageBubble>
        </Link>
        <Link
          className={cx(style.item, entity === 'existing' ? style.current : '')}
          to={'/admin/existing'}
          onClick={onClick}
        >
          <IconUserCard className={style.icon}></IconUserCard>
        </Link>
      </div>
      <div className={style.bottomItems}>
        <Link to={'/'}>
          <ExitIcon className={style.exit}></ExitIcon>
        </Link>
      </div>
    </div>
  );
}
